import { PropsWithChildren, ReactNode } from "react";

import { GamificationModalTitleContainer } from "./styles";

export const GamificationModalTitle = ({
  children,
}: PropsWithChildren<ReactNode>) => {
  return (
    <GamificationModalTitleContainer>
      {children}
    </GamificationModalTitleContainer>
  );
};
